import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectOpenAiTokens } from '../../../../mainApp/features/DataSlice/dataSlice';
import {
  ContentHeader,
  ContentSection,
  SectionTitle,
  SectionDescription,
  SettingsWrapper
} from '../../SettingsBar/styled';
import { StyledButton } from '../../Bots/styled';

const InfoHub = () => {
  const openAiTokens = useSelector(selectOpenAiTokens);
  const navigate = useNavigate();

  return (
      <SettingsWrapper isInfoHub style={{ marginBottom: '2rem'}}>
      <ContentSection style={{ borderTop: 'none' }} >   
        <ContentSection>
          <SectionTitle>Jakie są limity użytkowania?</SectionTitle>
          <SectionDescription>
            Limity zależą od wybranego planu subskrypcji:
            <ul style={{ margin: '10px 0 0 20px' }}>
              <li><b>Standard:</b> Dowolna ilość zapytań do asystentów Standard w ramach limitu 3500 tokenów/msc. Ograniczona ilość zapytań do asystentów Premium (5 do wyszukiwarki, 3 zapytania do innych: muzyka, wideo, lektor, obrazy). Tokeny resetują się do poziomu 3500 co miesiąc.</li>
              <li><b>Premium:</b> Dowolna ilość zapytań do asystentów Standard oraz Premium w ramach limitu 7000 tokenów/msc. Tokeny resetują się do poziomu 7000 co miesiąc.</li>
            </ul>
          </SectionDescription>
        </ContentSection>
         <ContentSection>
          <SectionTitle>Co to są tokeny?</SectionTitle>
          <SectionDescription>
            Tokeny to jednostki używane do generowania treści w aplikacji. Każda operacja AI kosztuje określoną liczbę tokenów w zależności od złożoności zadania.
          </SectionDescription>
        </ContentSection>
        <SectionTitle>Jak działają tokeny?</SectionTitle>
        <SectionDescription>
          • Generowanie tekstu: 1-10 tokenów na operację*<br/>
          • Treści internetowe: 12-15 tokenów na operację*<br/>
          • Generowanie obrazów: 12-30 tokenów na obraz*<br/>
          • Generowanie muzyki: 40 tokenów na utwór<br/>
          • Generowanie wideo: 50-150 tokenów na film*<br/>
          <p style={{ fontSize: '10px', marginTop: '10px' }}>* w zależności od złożoności operacji</p>
        </SectionDescription>
        <ContentSection>
          <SectionTitle>Limity tokenów</SectionTitle>
          <SectionDescription>
            • Plan Standard: 3500 tokenów miesięcznie, odnawialne każdego miesiąca (Tokeny nie sumują się)<br/>
            • Plan Premium: 7000 tokenów miesięcznie, odnawialne każdego miesiąca (Tokeny nie sumują się)<br/>
            • Dodatkowe tokeny można dokupić w dowolnym momencie
          </SectionDescription>
        </ContentSection>
        <StyledButton onClick={() => navigate('/pricing')}>
          Wróć do planów
        </StyledButton>
      </ContentSection>
     </SettingsWrapper>
  );
};

export default InfoHub;


